import { render, staticRenderFns } from "./FlashModal.vue?vue&type=template&id=dbbd8940"
import script from "./FlashModal.vue?vue&type=script&lang=js"
export * from "./FlashModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports